/* Runs once when the feature registry loads (index.ts is imported eagerly by the shell), so these apply
   app-wide before the Settings screen is ever opened:
   - PLAT-04 accessibility attributes on <html> from the last saved preferences, then the API's copy;
   - PLAT-03 <html lang dir> from the last chosen UI language;
   - PLAT-02 the offline cache for chat history reads.
   Core should own this eventually (requested in docs/core-requests.md); it lives here meanwhile. */
import './global.css';
import { api } from '../../lib/api';
import { applyAccessibility, loadAccessibility, saveAccessibility } from './a11y';
import { applyLanguage, LANG_KEY } from './i18n';
import { installOfflineCache } from './offline';
import type { AccessibilityPrefs } from './types';

export function bootSettings(): void {
  if (typeof document === 'undefined') return;
  const a11y = loadAccessibility();
  if (a11y) applyAccessibility(a11y);
  try {
    const lang = localStorage.getItem(LANG_KEY);
    if (lang) applyLanguage(lang);
  } catch { /* storage blocked */ }
  if (import.meta.env.MODE === 'test') return;
  installOfflineCache();
  // Refresh from the API when signed in (401 or no API: keep the local copy).
  api.get<{ preferences: AccessibilityPrefs }>('/api/v1/preferences/accessibility')
    .then((r) => { if (r?.preferences) { applyAccessibility(r.preferences); saveAccessibility(r.preferences); } })
    .catch(() => undefined);
}

bootSettings();
